export default "__VITE_ASSET__CQYlJx3K__"